import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'

const GroupContent = styled.section`
  padding: 2em 0 0;
  margin-bottom: -40px;
  p {
    font-size: 25px !important;
    line-height: 40px !important;
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h2 {
      text-align: left;
    }
  }
`

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  iframe {
    padding-top: 20px;
    @media ${device.mobileL} {
      height: 260px;
    }
  }
  a {
    color: #8e8fc7;
  }
  .intro {
    padding: 3em 2em;
    position: relative;
    background: linear-gradient(to top, #8accb7, #006a65);
    margin-top: 20px;
    @media ${device.mobileL} {
      padding: 266px 2em 2em !important;
    }
    .image {
      position: absolute;
      display: block;
      bottom: -3.4em;
      right: 200px;
      width: 237px;
      z-index: 3;
      @media ${device.mobileL} {
        right: inherit;
        bottom: inherit;
        left: 40px;
        width: 210px;
        top: -271px;
      }
    }
    @media ${device.mobileL} {
      padding: 1.5em;
    }
    div {
      @media ${device.tablet} {
        width: 50%;
        font-weight: normal;
        font-size: 1em;
        margin-left: 5%;
      }
      @media ${device.mobileL} {
        width: 100%;
        font-weight: normal;
        font-size: 0.8em;
        margin-left: 0;
        box-sizing: border-box;
      }
    }
    .inner {
      border-bottom: 6px #ffffff solid;
      border-left: 6px #ffffff solid;
      border-right: 6px #ffffff solid;
      padding: 1em 2em;
      margin: 0 -90px;
      position: relative;
      min-height: 100px;
      display: flex;
      align-items: center;
      color: #ffffff;
      @media ${device.mobileL} {
        border: 6px #ffffff solid;
        display: block;
        padding: 2em 2em;
      }
      :before {
        content: '';
        background: #ffffff;
        width: 2%;
        height: 6px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        @media ${device.mobileL} {
          display: none;
        }
      }
      :after {
        content: '';
        background: #ffffff;
        width: 61%;
        height: 6px;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        @media ${device.mobileL} {
          display: none;
        }
      }
      h1 {
        font-size: 2em;
        position: absolute;
        top: -60px;
        left: 20px;
        padding: 0 0.5em;
        font-weight: normal;
        color: #ffffff;
      }
      p {
        font-size: 1em;
        width: 100%;
        max-width: 450px;
        line-height: 1.6em;
        @media ${device.mobileL} {
          width: 100%;
          font-size: 1.5em;
          text-align: left;
        }
      }
      @media ${device.mobileL} {
        margin: 0;
        h2 {
          position: initial;
          text-align: left;
          padding: 0;
        }
      }
    }
  }

  .QA {
    @media ${device.mobileL} {
      margin: 2em 1.5em;
    }
    h2 {
      font-size: 1.5em;
      color: #148581;
      padding: 0;
      font-weight: normal;
      margin-bottom: 0.6em;
      svg {
        vertical-align: top;
        margin-right: 10px;
        margin-top: 4px;
      }
      @media ${device.mobileL} {
        position: initial;
        text-align: left;
        padding: 0;
      }
    }

    .tituloquestion {
      margin-top: 2.5em;
      margin-bottom: 1em;
      @media ${device.mobileL} {
        margin-top: 1em;
        font-size: 1.5em;
      }
    }
  }

  .accordion__heading {
    .accordion__button {
      :after {
        color: #148581;
        background: #d7f1f0;
      }
      h3 {
        color: #148581;
        :before {
          border: 1px solid #148581;
          opacity: 0.5em;
        }
        :after {
          border: 1px solid #148581;
          opacity: 0.5em;
        }
      }
      :hover {
        background: #148581;
        :after {
          background: #148581;
          color: #ffffff;
        }
        h3 {
          color: #ffffff !important;
          :before {
            border: 1px solid #fff;
          }
          :after {
            border: 1px solid #fff;
          }
        }
      }
    }
    .accordion__button[aria-expanded='true'] {
      background-color: #148581;
      color: #ffffff;
      :after {
        transform: rotate(-45deg);
        background-color: #148581;
        color: #ffffff;
      }
      h3 {
        color: #ffffff;
        :before {
          border: 1px solid #ffffff;
        }
        :after {
          border: 1px solid #ffffff;
        }
      }
    }
  }
  .resposta {
    padding-left: 2.5em;
    @media ${device.mobileL} {
      padding-left: 2em;
    }
    p {
      padding: 0;
      width: 100%;
      @media ${device.mobileL} {
        padding: 0;
      }
    }
  }
`

export const FaqTemplate = ({
  title,
  content,
  image,
  color,
  slug,
  area = 'O Santa Joana',
  faq,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          bottom="-66px"
          right="110px"
          imgWidth="450px"
          height="138px"
          overflow="visible"
        />
        <GroupContent>
          <div className="inner center">
            <p>Veja algumas perguntas frequentes e suas respostas:</p>
          </div>
        </GroupContent>
        <section className="QA">
          <div className="center">
            <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
              {faq.map(item => (
                <React.Fragment key={item.tituloTopico}>
                  <h2 className="tituloquestion">
                    <AiOutlineQuestionCircle />
                    {item.tituloTopico}
                  </h2>
                  {item.duvidas.map((child, index) => (
                    <AccordionItem key={index}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <h3>{child.duvida}</h3>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div
                          className="resposta"
                          dangerouslySetInnerHTML={{
                            __html: child.conteudo,
                          }}
                        />
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                </React.Fragment>
              ))}
            </Accordion>
          </div>
        </section>
        <GroupContent>
          <div className="inner center">
            <p>
              Ficou com alguma dúvida?{' '}
              <Link to="/fale-conosco">Clique aqui</Link> e fale conosco.
            </p>
          </div>
        </GroupContent>
      </Container>
    </>
  )
}

FaqTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const Faq = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''
  const faq = page.faq.duvidasFrequentes

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <FaqTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        faq={faq}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

Faq.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Faq

export const FaqQuery = graphql`
  query FaqById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      faq {
        duvidasFrequentes {
          ... on WpPage_Faq_DuvidasFrequentes_Topico {
            fieldGroupName
            tituloTopico
            duvidas {
              ... on WpPage_Faq_DuvidasFrequentes_Topico_Duvidas_InserirDuvidas {
                conteudo
                duvida
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
